import React from 'react';
import styles from './FooterNav.scss';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useActiveEntity } from '#modules/api/User';
import Icon from '#components/Elements/Icon/Icon';
import Tooltip from '#components/Elements/Tooltip/Tooltip';
import * as modalRoutes from '#app/containers/modalRoutes';
import { locationToOpenModal } from '#app/containers/routes';

const FooterNavButton = ({ label, icon, onClick, disabled, isPrimary }) => (
  <button
    className={classNames(styles.footerNavButton, {
      [styles.disabled]: disabled,
      [styles.isPrimary]: isPrimary,
    })}
    onClick={onClick}
    disabled={disabled}
  >
    <Icon icon={icon} className={styles.icon} />
    <span className={styles.label}>{label}</span>
  </button>
);

const FooterNav = () => {
  const location = useLocation();
  const history = useHistory();
  const intl = useIntl();
  const entity = useActiveEntity();
  const isRestricted = entity?.restricted === true;
  const isUnverified = entity?.checked === false;
  const isRestrictedOrUnverified = isRestricted || isUnverified;

  const buy = React.useCallback(
    () =>
      history.push(
        locationToOpenModal(
          location,
          modalRoutes.WALLET_BUY,
          null,
          {
            details: 0,
            scope: 'default',
          },
          true,
        ),
      ),
    [history, location],
  );

  const send = () =>
    history.push(locationToOpenModal(location, modalRoutes.WALLET_SEND));

  const deposit = () =>
    history.push(
      locationToOpenModal(location, modalRoutes.WALLET_DEPOSIT_INSTRUMENTS),
    );

  const sell = () =>
    history.push(
      locationToOpenModal(location, modalRoutes.WALLET_SELL, null, {
        details: 0,
      }),
    );

  let restrictedMessage = intl.formatMessage({
    defaultMessage: 'This feature is not available in your region',
  });

  if (isUnverified) {
    restrictedMessage = intl.formatMessage({
      defaultMessage:
        'This feature is not available until you verify your identity',
    });
  }

  const navItems = [
    {
      label: 'Buy',
      tooltip: 'Buy commodities',
      icon: 'icon-plus',
      action: buy,
    },
    {
      label: 'Transfer',
      tooltip: 'Transfer your bullion entitlement to another verified customer',
      icon: 'icon-arrow-up',
      action: send,
    },
    {
      label: 'Add funds',
      tooltip: 'Top up your purchase credit',
      icon: 'icon-arrow-down',
      action: deposit,
    },
    {
      label: 'Sell',
      tooltip: 'Sell commodities',
      icon: 'icon-minus-circle',
      action: sell,
    },
  ];

  return (
    <nav className={classNames(styles.footerNav, styles.onlyOnMobile)}>
      {navItems.map((item, index) => (
        <Tooltip
          key={item.label}
          wrapperClassName={styles.tooltipWrapper}
          targetClassName={styles.tooltipTarget}
          text={
            isRestrictedOrUnverified ? (
              restrictedMessage
            ) : (
              <FormattedMessage
                defaultMessage="{tooltip}"
                values={{ tooltip: item.tooltip }}
              />
            )
          }
        >
          <FooterNavButton
            label={item.label}
            icon={item.icon}
            onClick={item.action}
            disabled={isRestrictedOrUnverified}
            isPrimary={index === 0}
          />
        </Tooltip>
      ))}
    </nav>
  );
};

export default FooterNav;
